import {
  ActionReducerMap,
  createFeatureSelector,
  ActionReducer,
  MetaReducer,
} from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import * as fromUser from '../../shared/store/reducers/user.reducer';
import * as fromContext from '../../shared/store/reducers/context.reducer';
import * as fromInstitution from '../../shared/store/reducers/institution.reducer';
import * as fromBuildingInventory from '../../shared/store/reducers/building-inventory.reducer';
import * as fromReplacementValues from '../../insurance/store/reducers/replacement-values.reducer';
import * as fromCategories from '../../insurance/store/reducers/categories.reducer';
import * as fromGrid from '../../insurance/store/reducers/grid.reducer';
import * as fromGroups from '../../insurance/store/reducers/groups.reducer';
import * as fromInstitutionInsurances from '../../insurance/store/reducers/institution-insurance.reducer';
import * as fromLocations from '../../insurance/store/reducers/locations.reducer';
import * as fromImport from '../../insurance/store/reducers/import.reducer';
import * as fromInstitutionSummary from '../../capital/store/reducers/institution-summary.reducer';
import * as fromProjectSchedule from '../../capital/store/reducers/project-schedule.reducer';
import * as fromPredictionSchedule from '../../capital/store/reducers/prediction-schedule.reducer';
import * as fromLookupList from '../../capital/store/reducers/lookup-list.reducer';
import * as fromCapitalRenewalStatus from '../../insurance/store/reducers/capital-renewal-status.reducer';
import * as fromUserPreferences from '../../shared/store/reducers/user-preferences.reducer';
import * as fromReportParameters from '../../insurance/store/reducers/report-parameters.reducer';
import * as fromTransSummaryByBuilding from '../../capital/store/reducers/trans-summary-by-building.reducer';
import * as fromTransSummaryByLevel3 from '../../capital/store/reducers/trans-summary-by-level3.reducer';
import * as fromTransPredictionByBuilding from '../../capital/store/reducers/trans-prediction-by-building.reducer';

import {
  RouterStateSnapshot,
  Params,
  ActivatedRouteSnapshot,
} from '@angular/router';

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
}

export const getRouterState = createFeatureSelector<
  fromRouter.RouterReducerState<RouterStateUrl>
>('routerReducer');

export class CustomRouterStateSerializer
  implements fromRouter.RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const { url } = routerState;
    const { queryParams } = routerState.root;

    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }
    const { params } = state;

    return { url, queryParams, params };
  }
}

export interface State {
  userReducer: fromUser.UserState;
  routerReducer: fromRouter.RouterReducerState<RouterStateUrl>;
  contextReducer: fromContext.ContextState;
  institutionReducer: fromInstitution.InstitutionState;
  buildingInventoryReducer: fromBuildingInventory.BuildingInventoryState;
  replacementValuesReducer: fromReplacementValues.ReplacementValuesState;
  categoriesReducer: fromCategories.CategoriesState;
  gridReducer: fromGrid.GridState;
  groupsReducer: fromGroups.GroupsState;
  institutionInsurancesReducer: fromInstitutionInsurances.InstitutionInsurancesState;
  locationsReducer: fromLocations.LocationsState;
  importReducer: fromImport.ImportState;
  institutionSummaryReducer: fromInstitutionSummary.InstitutionSummaryState;
  projectScheduleReducer: fromProjectSchedule.ProjectScheduleState;
  predictionScheduleReducer: fromPredictionSchedule.PredictionScheduleState;
  lookupListReducer: fromLookupList.LookupListState;
  capitalRenewalStatusReducer: fromCapitalRenewalStatus.CapitalRenewalStatusState;
  userPreferencesReducer: fromUserPreferences.UserPreferencesState;
  reportParametersReducer: fromReportParameters.ReportParametersState;
  transSummaryByBuildingReducer: fromTransSummaryByBuilding.TransSummaryByBuildingState;
  transSummaryByLevel3Reducer: fromTransSummaryByLevel3.TransSummaryByLevel3State;
  transPredictionByBuildingReducer: fromTransPredictionByBuilding.TransPredictionByBuildingState;
}

export const reducers: ActionReducerMap<State> = {
  userReducer: fromUser.userReducer,
  routerReducer: fromRouter.routerReducer,
  contextReducer: fromContext.contextReducer,
  institutionReducer: fromInstitution.institutionReducer,
  buildingInventoryReducer: fromBuildingInventory.buildingInventoryReducer,
  replacementValuesReducer: fromReplacementValues.replacementValuesReducer,
  categoriesReducer: fromCategories.categoriesReducer,
  gridReducer: fromGrid.gridReducer,
  groupsReducer: fromGroups.groupsReducer,
  locationsReducer: fromLocations.locationsReducer,
  institutionInsurancesReducer: fromInstitutionInsurances.institutionInsurancesReducer,
  importReducer: fromImport.importReducer,
  institutionSummaryReducer: fromInstitutionSummary.institutionSummaryReducer,
  projectScheduleReducer: fromProjectSchedule.projectScheduleReducer,
  predictionScheduleReducer: fromPredictionSchedule.predictionScheduleReducer,
  lookupListReducer: fromLookupList.lookupListReducer,
  capitalRenewalStatusReducer: fromCapitalRenewalStatus.capitalRenewalStatusReducer,
  userPreferencesReducer: fromUserPreferences.userPreferencesReducer,
  reportParametersReducer: fromReportParameters.reportParametersReducer,
  transSummaryByBuildingReducer: fromTransSummaryByBuilding.transSummaryByBuildingReducer,
  transSummaryByLevel3Reducer: fromTransSummaryByLevel3.transSummaryByLevel3Reducer,
  transPredictionByBuildingReducer: fromTransPredictionByBuilding.transPredictionByBuildingReducer,
};

export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return function (state: State, action: any): State {
    console.groupCollapsed('Action reducer ' + action.type);
    console.log('state', state);
    console.log('action', action);
    console.groupEnd();
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<State>[] = [logger];
